import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNotifier } from "react-headless-notifier";
import { Modal, Button, Input, FormGroup, NotifierNotification } from "@mwi/ui";
import { useCreateUserMutation } from "api";
import useErrorHandler from "hooks/useErrorHandler";
import CreateUserRequest from "api/types/requests/user/create_user";

const CreateAdminModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element => {
  const { notify } = useNotifier();
  const errorHandler = useErrorHandler();

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm<CreateUserRequest>();

  const [createUser, { data: createdUser, isLoading, error }] =
    useCreateUserMutation();

  useEffect(() => {
    if (error) {
      errorHandler(error, setError);
    }
  }, [error]);

  useEffect(() => {
    if (createdUser) {
      handleClose();

      notify(
        <NotifierNotification
          title="User Invited"
          message="User invitation successfully sent"
        />,
      );
    }
  }, [createdUser]);

  const handleClose = () => {
    onClose();
    reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      className="!max-w-[736px] w-full"
    >
      <Modal.Header title="Add new user" />

      <form onSubmit={handleSubmit(createUser)}>
        <Modal.Content>
          <p className="mb-10">
            Enter the email address of the person you want to add to the
            platform.
          </p>

          <FormGroup error={errors.email?.message}>
            <div className="flex items-center justify-between gap-6">
              <Input {...register("email")} placeHolder="E-mail" />

              <Button
                type="submit"
                loading={isLoading}
                className="whitespace-nowrap"
              >
                Send invitation
              </Button>
            </div>
          </FormGroup>
        </Modal.Content>
      </form>
    </Modal>
  );
};

export default CreateAdminModal;
